module.exports = __webpack_public_path__ + "assets/img/modal-avatar-0e0e868f.png";